import { render, staticRenderFns } from "./BaseCollapsibleForm.vue?vue&type=template&id=7495d2ea&scoped=true"
import script from "./BaseCollapsibleForm.vue?vue&type=script&lang=js"
export * from "./BaseCollapsibleForm.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapsibleForm.vue?vue&type=style&index=0&id=7495d2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495d2ea",
  null
  
)

export default component.exports